import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

export const Callout = (props) => {
  const {
    errorMessage,
    successMessage,
    extendClass = '',
    children,
    childrenBlockClass = 'callout-error',
  } = props;

  return (
    <>
      {errorMessage && (
        <div className="callout-row" data-testid="callout-error">
          <div className={`callout-container callout-error ${extendClass}`}>
            <p>{parse(errorMessage)}</p>
          </div>
        </div>
      )}

      {successMessage && (
        <div className="callout-row" data-testid="callout-success">
          <div className={`callout-container callout-success ${extendClass}`}>
            <p>{parse(successMessage)}</p>
          </div>
        </div>
      )}

      {children && (
        <div className="callout-row" data-testid="callout-block">
          <div className={`callout-container ${childrenBlockClass} ${extendClass}`}>{children}</div>
        </div>
      )}
    </>
  );
};

Callout.propTypes = {
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  extendClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  childrenBlockClass: PropTypes.string,
};
